export const blackCards = [
  "will be running late and can't find a parking spot",
  "will have to wait through 3 green lights before turning left",
  "will marry someone who never knows what they want to eat but hates all [2] suggestions",
  "will forget [2] password and the \"Forgot Password\" option won't work",
  "will have a tramp stamp of [2] toxic ex's name",
  "will support a sports team that is allergic to winning",
  "will have a roommate who eats everyone else's food",
  "will do all the work in a group project and get the lowest grade",
  "will be \"promoted\" with more responsibilities and no raise",
  "will only receive birthday messages from businesses' automated messaging systems",
  "will be ugly",
  "will live on the bottom floor of an upstairs nightclub",
  "will have a neighbor with a dog that is a professional barker",
  "will marry someone who is just in it for a Green Card",
  "will be 200k in student debt for a Latin studies degree",
  "will have squatters in [2] home",
  "will be [2] dog's least favorite human",
  "will have a pet unable to be potty trained",
  "will be cheated on by [2] partner with the partner's coworker",
  "will discover [2] best friend and partner are having an affair",
  "will realize [6] not the father of [2] kids",
  "will drink a cup of expired milk",
  "will have [2] dream house destroyed by a natural disaster",
  "will never be able to find parking near [2] house",
  "will live in a haunted house",
  "will be cut from the Sunday league adults softball team",
  "will sit next to a talkative person on the plane",
  "will sit behind a crying baby in a 10-hour-flight",
  "will try to sleep on the plane while the person next to [3] has to use the restroom every 10 minutes",
  "will have [2] flight delayed just enough to miss [2] connection",
  "will lose [2] headphones right before an 18-hour flight",
  "will fail a class by .01%",
  "will study and still fail the exam",
  "will answer the teacher's question correctly, but someone else says it louder",
  "will be cyberbullied",
  "will get the answer wrong because [1] rounded to two decimal places instead of three",
  "will take a class by a professor known as the worst teacher on campus",
  "will walk into class and realize there is a test today",
  "will have a professor whose exam is nothing like the class lectures",
  "will pay 65k per semester just for professors to read off the slides",
  "will finally talk to [2] crush just to be friend-zoned",
  "will be forced to engage in small talk",
  "will be passed up for a promotion for being a woman",
  "will have to work so much that [2] kids don't recognize [3]",
  "will work 80 hours a week, be cheated on then be left by [2] spouse",
  "will be replaced by AI at [2] work",
  "will run out of toilet paper visiting [2] partner's parents house for the 1st time",
  "will try to become an influencer and will receive hate in response",
  "will be booed after making an announcement on stage",
  "will spend thousands on designer clothing just to find out it is fake",
  "will discover [2] roommate is a nudist after signing a year lease with them",
  "will have a roommate who always hogs the restroom in the morning",
  "will have a roommate who never washes the dishes",
  "will have a roommate who blasts shitty music late at night",
  "will have a roommate who is always late on rent",
  "will live in an apartment with a horrible smell that won't go away",
  "will come back from winter break to discover a used condom in [2] bed",
  "will get shit on by a bird at the beach",
  "will pay for a $50 car wash then have [2] car shitted on by a bird",
  "will step on gum in [2] new shoes",
  "will have class at 8 am every day of the week",
  "will have shitty weather during [2] vacation",
  "will realize [1] lost [2] passport at the airport during international travel",
  "will discover a hair in the last bite of [2] meal",
  "will be stuck arguing with virtual assistants unable to talk to a human",
  "will accidentally like [2] ex's picture from 2 years ago",
  "will accidentally like [2] crush's oldest picture on social media",
  "will accidentally sext [2] dad instead of the current hook-up",
  "will run out of small talk topics and awkwardly stare",
  "will receive \"wtf\" looks instead of laughs when making jokes",
  "will send a screenshot of the message to the person [1] screenshotted",
  "will have ugly kids",
  "will miss [2] flight by 1 minute",
  "will get stuck in a hurricane during [2] honeymoon",
  "will have [2] travel buddies get arrested",
  "will receive a birthday divorce instead of birthday cake",
  "will break [2] New Year's resolution on January 2nd",
  "will watch [2] server sneeze in someone else's food mid-bite",
  "will not keep up with inflation",
  "will always drive through an hour of traffic to get to work every day",
  "will speed for the first time and get a ticket",
  "will not be able to merge",
  "will miss [2] exit on the freeway and have a 30-minute detour",
  "will have [2] car AC go out on the hottest day of the year",
  "will be honked at by other drivers simply for going the speed limit",
  "will drive behind a bicycle on a one-lane road for 5 miles",
  "will see a cockroach while taking a shower",
  "will be locked outside the hotel room naked",
  "will have water get cold mid-shower while covered in soap",
  "will discover there are bed bugs after spending the night at the hotel",
  "will become an \"influencer\" yet influence no one",
  "will be addicted to social media and realize [7] wasted years of [2] life",
  "will lose [2] life savings following financial advice from a social media investment guru",
  "will have relatives comment embarrassing stuff on [2] social media post",
  "will be following GPS in an unknown area when [2] phone dies",
  "will have [2] jaw hurt for having to fake laugh",
  "will have the server say [2] card is declined on a first date",
  "will have a hard time finding love",
  "will desperately need to shit while stuck in standstill traffic",
  "will be too embarrassed to show [2] friends pictures of [2] new partner",
  "will show [2] friends a picture of [2] partner and they will say \"As long as you are happy\"",
  "will find the love of [2] life then get cheated on",
  "will be in credit card debt after [2] dates food choices",
  "will spend $1,000 on a date, then get ghosted instead of laid",
  "will realize [13] [2] date",
  "will be catfished by [2] date",
  "will work up the courage to follow [2] crush on social media and won't get a follow-back",
  "will say something stupid in front of [2] crush",
  "will get in a car accident test driving a brand new car at the dealership",
  "will have [2] car stranded in the snow",
  "will have no one laugh at [2] jokes",
  "will wave at someone but they do not see it",
  "will get interrupted in the middle of the joke punchline",
  "will realize the food order from the drive-thru is wrong, once [9] home",
  "will get scammed and be too embarrassed to tell anyone",
  "will be rejected solely based on [2] astrological sign",
  "will forget what [6] saying mid-sentence",
  "will get birthday cards with no money",
  "will have [2] birthday forgotten by [2] friends and family",
  "will not be invited to [2] friend's birthday party",
  "will have a conventionally ugly partner",
  "will fart and it smells so bad someone throws up",
  "will be married to someone who snores",
  "will wait for marriage and realize [2] spouse is horrible at sex",
  "will realize [2] boyfriend has bigger boobs than [3]",
  "will not be able to grow a beard",
  "will have a taxi driver who won't stop talking to [3]",
  "will be broken up with on [2] wedding day",
  "will oversleep and miss [2] wedding",
  "will have [2] favorite TV show discontinued",
  "will run out of movies and TV shows to watch",
  "will try a new diet and gain weight instead of losing it",
  "will get denied by insurance for a 20k hospital bill",
  "will be assigned an incompetent doctor for a major surgery",
  "will have the dentist accidentally remove the wrong tooth",
  "will have third-degree burns from a trip to the beach",
  "will have an airport built right next to [2] house",
  "will have a cashier checkout as slow as humanly possible",
  "will pick the slowest line at the register",
  "will be forced to wait while [2] partner shops for hours",
  "will not grab a cart and end up carrying a bunch of stuff around the supermarket",
  "will buy some fruit, bread, and milk and [2] total is $300",
  "will no longer have friends",
  "will become an alcoholic",
  "will be uninvited from a friend's wedding",
  "will introduce two friends to each other, and they start hanging out without [3]",
  "will show [2] friend a song and they say they do not like it before the chorus starts",
  "will sing in the shower and get a noise complaint from the neighbors",
  "will have a really annoying song stuck in [2] head",
  "will ruin [2] favorite song by listening to it on repeat",
  "will wear headphones for some damn peace and still get bothered by an extravert",
  "will live paycheck to paycheck for [2] entire life",
  "will work 80 hours a week, make minimum wage, and have a negative bank balance",
  "will be at [2] lowest point, then somehow go lower",
  "will win the lottery but lose the winning ticket",
  "will finally have a good paying job and spend it all to keep [2] high maintenance girlfriend happy",
  "will work out religiously and only make marginal gains in physique",
  "will go to the gym daily for years and never get a six-pack",
  "will have [2] favorite gym equipment taken",
  "will be rejected solely based on [2] height",
  "will be kicked out of the gym for staring at women when [14] just dazing off",
  "will realize [2] gym crush has a significant other",
  "will have [2] gym crush report [3] for being creepy",
  "will have the pharmacist yell out that [2] STD medication is ready",
  "will have a piece of popcorn stuck in [2] teeth",
  "will have lice in [2] pubic hair",
  "will get a flat tire on the way to the airport in the middle of the night",
  "will have to pee while having a boner",
  "will smell bad and no one will tell [3]",
  "will buy expensive healthy groceries but they expire before [1] can cook them",
  "will burn everything [15] to cook",
  "will cook for [2] partner and it is so bad [2] partner throws up",
  "will not remember if [1] turned the oven off before leaving the house",
  "will have to eat gross food out of politeness",
  "will have a professor with an incomprehensible accent",
  "will need a car repair that costs more than the value of the car",
  "will have other people treat [2] car like a trash can",
  "will run of out gas in the middle of the highway",
  "will have [2] view blocked at the concert by an extremely tall giant of a man",
  "will have guests overstay [2] welcome",
  "will be caught in a stupid white lie that spins out of control",
  "will have the bank teller talk loudly about how [7] $12 and 36 cents in [2] account",
  "will be greeted by someone [1] can't recall",
  "will be too shy to function properly in society",
  "will try to tell a funny story and get interrupted ten times by useless questions",
  "will have someone use the urinal right next to [4] in an empty restroom",
  "will try to cheat on the test, fail anyway, and get caught by the professor",
  "will eat a lot of snacks but never be a snack",
  "will get a boner during a presentation",
  "will be caught while taking a picture of a stranger",
  "will be caught while picking [2] nose",
  "will be caught for talking to multiple people at once",
  "will be about to fall asleep and jolt awake from a dream that [6] falling",
  "will be cozy in bed but have to pee",
  "will have a mid-life crisis at 22",
  "will pull a baddie then be too nervous to get hard for sex",
  "will have a dream [6] going to the bathroom and pee the bed",
  "will father 3 children from a bad pull-out game",
  "will get pregnant the one time [16] [2] hookup's pull-out game",
  "will last in bed for less time than a commercial",
  "will be asked \"Have you put it in\" when it is already fully inside",
  "will forget an important anniversary",
  "will have [2] partner be mad at [3] because [1] said [1] wouldn't date them if they were a worm",
  "will be asked what's the last book [1] read and realize [7] never read a book",
  "will think [6] letting out a silent fart and instead a trumpet sound comes from [2] ass",
  "will tap someone's shoulder [17] [18] but it's a complete stranger",
  "will have an itch in [2] dick that will not go away",
  "will need to itch [2] ass while giving a presentation",
  "will be [2] in-laws' enemy",
  "will start therapy and realize [6] the problem",
  "will have slow internet when [6] in a hurry",
  "will close [2] computer without saving [2] finished 10-page essay",
  "will get stuck in the elevator with no service and no help button",
  "will flip the camera on accident and realize how ugly [6]",
  "will watch a movie with [2] parents and an explicit sex scene appears",
  "will have [2] phone die during a long big dump",
  "will have a giant penis but doesn't know how to use it",
  "will slide in the DMs and get left on read",
  "will be unable to spell anything correctly without spell check",
  "will repel women instead of attract",
  "will have a 100% reject rate in dating",
  "will never break up with [2] partner who is a chronic cheater",
  "will be a virgin but not by choice",
  "will have a micropenis",
  "will be in a toxic relationship because sex is just too good",
  "will be forced to have a joint social media account with [2] partner",
  "will have a needy partner",
  "will have a long-distance girlfriend who has a 6.5 feet tall personal trainer",
  "will have three different baby daddies",
  "will be into some freaky stuff and [2] partner is vanilla",
  "will never get to be the little spoon",
  "will be into feet and fall in love with someone with gross feet",
  "will try to spice it up in the bedroom and be made fun of by [2] partner",
  "will try an online dating site and get 0 matches then be banned from the site",
  "will try a threesome with [2] partner and end up being the one feeling left out",
  "will get into a physical fight and [2] butt crack shows",
  "will have [2] partner share half-naked pics on social media but never sent [3] any nudes",
  "will go to a comedy show and get blasted by the comedian",
  "will get a 0 on an assignment for turning in the wrong format",
  "will apply but not get into any sororities",
  "will discover all [2] friends are hanging out without [3] via social media",
  "will try to be more active and get lost on [2] first hike",
  "will be really sad and think things are getting better, then get even sadder",
  "will try to join a bowling league and get cut in tryouts",
  "will get destroyed in mini-golf by [2] partner",
  "will pick up bird watching as a hobby and get arrested in the park for suspicious behavior",
  "will shave, put on makeup, and pick out the perfect outfit, then have [2] date cancel",
  "will tell [2] partner [7] a foot fetish and get broken up with instead of accepted",
  "will get broken up with and laid off during the week of Christmas",
  "will get told [2] house smells bad by visitors",
  "will have a really hot girlfriend but she is bat shit crazy",
  "will pay a bunch of taxes and still owe money at the end of the year",
  "will wear something risque and get called slutty instead of sexy",
  "is cool, let [3] live [2] life",
  "will spill [2] hot coffee on [4] leaving [2] house",
  "will be unable to find [2] car keys when [6] already running late",
  "will sleep through [2] phone alarm because [2] phone is dead",
  "will step in a big puddle in open-toed shoes",
  "will get pounded by life instead of a man",
  "will be splashed by water from a car speeding by",
  "will put on sunscreen and still get sunburned",
  "will try to go blonde but [2] hair turns orange instead",
  "will always be cock blocked by [2] family",
  "will want to have sex in the car but won't know where to park",
  "will get blackout drunk the night before and wake up in jail",
  "will marry an old dude for money but he ends up being very healthy",
  "will have [2] mom not answer [2] emergency call",
  "will start going to karate and get beat up on the first day",
  "will be beat up by a pack of girls",
  "will have a partner who does way too much eye contact in bed",
  "will have a partner with no stamina",
  "will get ghosted",
  "will have [2] skincare routine make [2] skin worse",
  "will start having grey hair",
  "will constantly be reminded that \"The clock is ticking\"",
  "will be constantly underestimated for being a woman",
  "will hear that [2] ex is saying their sex life with [3] was terrible",
  "will be dating someone for 10 years who still isn't ready to commit",
  "will have zero sense of humor",
  "will date a 10 with the personality of a brick",
  "will laugh during serious moments",
  "will have trust issues with [2] partner",
  "will turn on [2] favorite music, and someone says \"what the fuck is this crap\"",
  "will follow online nutrition advice and end up in the hospital",
  "will set a personal record of 1 minute in bed",
  "will live on the 25th floor, and the elevator is not working",
  "will pay for expensive food that doesn't taste good",
  "will fake orgasms because [2] partner is so bad in bed",
  "will have [2] vibrator chewed up by [2] dog",
  "will be so desperate [1] will use an electric toothbrush as a vibrator",
  "will get a parking ticket during car sex",
  "will be laughed at when a woman sees [2] penis",
  "will try for one kid and get quadruplets instead",
  "will have [2] sugar daddy go broke",
  "will get a botched boob job",
  "will get a phone call from [2] spouse mid-sex",
  "will get left for the opposite gender",
  "will get into a car accident during road head",
  "will take an extra edible thinking the first wasn't hitting then get rocked into another universe",
  "will underestimate the power of three dicks at one time",
  "will be brainwashed",
  "will walk with a limp from a fight with a 13-inch dick",
  "will be in a threesome and not know what to do",
  "will have the quickie be a little too quick",
  "will struggle to not look down at woman's cleavage in a professional setting",
  "will have a partner that ruins [2] day every day",
  "will have the urge to shit mid-workout",
  "will get [2] dick slapped for no reason",
  "will have a roommate whose annoying partner is always over",
  "will have a toilet that gets clogged often",
  "will have [2] mobile order stolen at the restaurant",
  "will have a hook-up that thinks a hug counts as foreplay",
  "will discover [2] nipples are pierced after a crazy night out",
  "will not be able to finish",
  "will go to the meet-up location for a hook-up and get jumped instead",
  "will be very ticklish",
  "will get handcuffed thinking things are about to get freaky then get robbed",
  "will get blackmailed by a hooker",
  "will get reported as a stalker",
  "will break [2] bed during sex",
  "will have a very sexually active upstairs neighbor",
  "will walk around the house naked then realize there are guests over",
  "will get broken up with via email",
  "will text [2] girlfriend during a night out and receive \"she's busy bro\"",
  "will send toe pics for money but scammed instead",
  "will have all four of [2] tires stolen in the parking lot",
  "will stub [2] toe",
  "will have TSA pull out [2] strap from [2] carry-on bag",
  "will have [2] favorite dildo stolen",
  "will wake up from [2] one-night stand with [2] car keys missing",
  "will be weeks late to [2] period and wonder if [6] about to be a mother",
  "will try [2] best and still fail",
  "will be the joke of the friend group",
  "will get broken up with and told \"It's not you, it's me\"",
  "will have [2] car keyed by [2] crazy ex",
  "will kiss someone with chapped lips",
  "will be horny at the worst times",
  "will be intimidated by [2] girlfriend's dildo",
  "will have kids but never be a milf",
  "will fuck around and find out",
  "will start dating a prostitute",
  "will date someone with a high body count but now they want to wait for marriage",
  "will see [2] partner's head game significantly and suspiciously improve all of a sudden",
  "will have no head game",
  "will be the worst [2] hookup has ever had",
  "will push to open the relationship and see [2] partner sleep with a new person every day, but [1] can't get anyone",
  "will see [2] partner on dating sites",
  "will be back asking about favorite colors after 10-year-relationship",
  "will never make it far enough in a relationship to have sex",
  "will be horny but a vegan ate all the vegetables",
  "will be a grown-ass man but still be a pussy",
  "will have to sneeze but can't",
  "will have uncontrollable hiccups",
  "will fumble everyone [21] to",
  "will be so horny [1] will lower [2] standards",
  "will not get some for so long that [1] will start feeling like a virgin again",
  "will not be able to get over how great sex was with [2] ex",
  "will have a partner that doesn't take showering seriously",
  "will ignore all of someone's red flags because they give great head",
  "will have a wedgie that [1] can't pick",
  "will not be able to fit into [2] favorite jeans",
  "will get blackout drunk and twerk at the company party",
  "will have a drunk mistake from years before resurface and cause [2] divorce",
  "will be oddly attracted to [2] upstairs neighbor",
  "will get banned from [2] local grocery store for starting a fight in the produce section",
  "will have a weird obsession with shiny rocks",
  "will get blinded by money",
  "will be allergic to grass",
  "will be a snitch and end up in a ditch",
  "will be baby trapped",
  "will be blue balled",
  "will realize it's not as big as [1] thought it was",
  "will be dropped by [2] therapist",
  "will receive a slobbery wet kiss",
  "will tell a woman to calm down",
  "will hear about [2] friend's sex lives and realize [2] sex life sucks",
  "will have a clingy partner that never leaves [3] alone",
  "will realize [7] a problem and get drunk instead of fixing it",
  "will be the rebound",
  "will have women be offended when [22] on them",
  "will encounter some poison ivy while frolicking naked in the forest",
  "will lose [2] ID as soon as [9] to Vegas",
  "will be flashed by an old fat man in the park",
  "will always be a bad vibe",
  "will pay for a strip tease but forget to specify the gender",
  "will have a partner who is into crystals",
  "will always be the booty call",
  "will think [1] met the one but then find out they are actually a swinger",
  "will fall off the pole during [2] first pole dancing class",
  "will be sexually attracted to robots",
  "will get kicked in the balls",
  "will die a virgin",
  "will find earrings that aren't [4] in [2] partner's car",
  "will have [2] partner take role-playing during sex a little too seriously",
  "will have a very cute penis",
  "will have a partner that's all talk and no game",
  "will have 2 boyfriends and still feel single",
  "will have [2] partner and kids be against [2] girlfriend",
  "will be in a long-distance relationship with someone but can't afford plane tickets",
  "will have a partner who sends low-resolution nudes",
  "will never win an argument against [2] partner",
  "will be a fuckup",
  "will realize [2] date is there just for the free food",
  "will have a partner that talks too much during sex",
  "will have a partner who constantly corrects [3] in public",
  "will hear [2] friends talk about their crazy sex life and just nod …because can't relate",
  "will be ashamed to be seen in public with [2] date",
  "will find out [2] blind date is [2] boss",
  "will appear in the kiss cam with [2] sibling at a sports match",
  "will have a partner who only wants to have sex in the dark",
  "will never be able to experience [2] sexual fantasies",
  "will get caught by [2] partner for staring at other women's breasts",
  "will have a partner that does the bare minimum in bed",
  "will get mixed up with the wrong crowd",
  "will only date people who waste [2] time",
  "will be horny and broke and single",
  "will have all [2] hookups move away",
  "will have a partner who is obsessed with true crime",
  "will be not very flexible",
  "will shit [2] pants",
  "will get a boob job and realize it's not worth the back pain",
  "will be socially awkward",
  "will have [2] deepest darkest secrets exposed",
  "will be ignored when talking",
  "will have a brain freeze that won't go away",
  "will have [2] car towed",
  "will discover [2] zipper is down at the end of the day",
  "will receive so many tickets [1] will have to go to driving school",
  "will get a really bad haircut",
  "will have [2] dance moves made fun of at the club",
  "will be too broke to date in this economy",
  "will slip into some yellow snow",
  "will have [2] ideas ignored in the group project",
  "will have negative rizz",
  "will be so bad at sports that it's not even fun to play recreationally",
  "will realize [7] no hobbies",
  "will be a disappointment",
  "will be mediocre at [2] job",
  "will receive a misspelled tattoo",
  "will realize [6] not hearing about any gossip because [6] the gossip",
  "will realize [6] the side chick",
  "will try to sext [2] partner and be told to stop because it's a turn-off",
  "will realize [2] crush wants a relationship, just not with [3]",
  "will scuff [2] new white shoes",
  "will get caught in a sticky situation",
  "will show up way too early to a party",
  "will be called the wrong name by [2] partner",
  "will become an internet meme",
  "will be spit on by the person talking to [3]",
  "will be in a rush and stuck behind a crowd of slow walkers",
  "will be eating with someone who chews with their mouth open",
  "will have a stuffy nose but when [25] [2] nose nothing comes out",
  "will have [2] texts ignored when [26] an important question",
  "will only be attracted to people way out of [2] league",
  "will only be approached by old men at the bar",
  "will only attract toxic men",
  "will be confused whether [6] a beta or an alpha",
  "will give great head but never receive any",
  "will only receive attention from [2] partner when they wanna have sex",
  "will not be able to pop a pimple in an awkward spot",
  "will be known as \"the short guy\"",
  "will be addicted to drawing dicks",
  "will be at the wrong place at the wrong time",
  "will never have anything beyond situationships",
  "will slowly but surely lose [2] rizz",
  "will have everyone congratulate [2] ex for dumping [2] ass",
  "will be a terrible kisser",
  "will be the ugliest sibling",
  "will give a fake number to a dude and he calls to verify",
  "will see [2] ex celebrate their 1 year anniversary with their new partner right after they break up",
  "will not be the brightest",
  "will be told that [1] will be a father, even though [1] had a vasectomy",
  "will have diarrhea but not make it to the bathroom in time",
  "will spend thousands on a party no one shows up to",
  "will be snowed in when [2] evil inlaws are visiting",
  "will have a roommate who leaves their pubic hair in the shower",
  "will see [2] parents fighting in the comments with strangers about politics",
  "will give the ugly guy a chance just to have [2] heart broken",
  "will lose control of [2] car on an icy road",
  "will make dad jokes that even dads don't find funny",
  "will pay for a gym membership but only go twice a year",
  "will spend hours cooking a fancy meal [1] found online, but it tastes awful",
  "will have an itch that will not go away",
  "will fart and a piece of poop falls out",
  "will find out that [2] phone didn't charge all night, and now it's at 2%",
  "will realize [2] partner is a gold digger",
  "will not have a condom at hand and lose the opportunity",
  "will break a heal",
  "will always have the ugliest pictures of [3] posted on social media by [2] mom",
  "will mess up big time during a sports game while [2] crush is watching",
  "will be stuck in a toxic relationship",
  "will say \"hi\" to someone then realize [8] not know them",
  "will always have [2] advances rejected by [2] partner",
  "will send a two-minute video to a friend and they send \"LMAO\" after 10 seconds",
  "will have yellow teeth",
  "will have no one attend [2] funeral",
  "will have people say \"Thank God\" instead of \"Rest In Peace\" at [2] funeral",
  "will have [2] partner walk into the room naked while [6] on a video call",
  "will try to get a sugar daddy but realize there is no market for [2] looks",
  "will ask [2] partner for a back massage but they will only massage the butt",
];